import React from 'react';
import ServiceDescriptionSection from '../../components/ServiceDescriptionSection';
import ServiceLegalRepresentationRationale from '../../components/ServiceLegalRepresentationRationale';
import ServiceContactUsSection from '../../components/ServiceContactUs';

const ParentingMatters = () => {
  return (
    <div className='servicePage'>
      <div className='servicePageContent'>
        <div className="header">Parenting Matters</div>
        <div className="body">
          <ServiceDescriptionSection
            content="Parenting matters refer to disputes involving children, such as custody, visitation, and child support. These matters can arise during divorce, separation, or other family law proceedings. Resolving parenting disputes requires careful consideration of the child's best interests, parental responsibilities, and the family's circumstances. Legal advice and representation can help parents navigate the complexities of family law and reach fair and sustainable outcomes for their children."
          />
          <ServiceLegalRepresentationRationale
            header="Why You Need Legal Representation"
            content="Legal representation is crucial in parenting matters to protect your parental rights and advocate for your child's best interests. A family lawyer can provide guidance on your legal rights and obligations, help negotiate parenting arrangements, and represent you in court proceedings if necessary. By seeking legal advice early, you can better understand your options and work towards a positive resolution for your family."
          />
          <ServiceContactUsSection
            header="Contact Us for Expert Legal Advice"
            content="Our experienced family law team is here to assist with parenting matters and other family law issues. We provide compassionate and practical legal advice to help you navigate the complexities of family law and achieve the best outcomes for your family. Contact us today to discuss your parenting matter and how we can help."
          />
        </div>
      </div>
    </div>
  );
};

export default ParentingMatters;
